// src/services/featureFlagService.js
import flagsmith from 'flagsmith';

// Feature flag constants
export const FEATURES = {
  STRIPE_PAYMENTS: 'stripe_payments',
};

/**
 * Service for managing feature flags
 */
const featureFlagService = {
  /**
   * Initialize the feature flag client
   * @param {string} environmentID - Flagsmith environment ID
   * @returns {Promise} - Promise that resolves when initialization is complete
   */
  init: (environmentID) => {
    return flagsmith.init({
      environmentID,
      cacheFlags: true,
      enableLogs: process.env.NODE_ENV === 'development',
      defaultFlags: {
        [FEATURES.STRIPE_PAYMENTS]: false, // Default to disabled if server is unreachable
      },
    });
  },

  /**
   * Check if a feature is enabled
   * @param {string} featureName - Name of the feature to check
   * @returns {boolean} - Whether the feature is enabled
   */
  isFeatureEnabled: (featureName) => {
    return flagsmith.hasFeature(featureName);
  },

  /**
   * Get the value of a feature flag
   * @param {string} featureName - Name of the feature
   * @returns {any} - Value of the feature flag
   */
  getFeatureValue: (featureName) => {
    return flagsmith.getValue(featureName);
  },

  /**
   * Update feature flags from the server
   * @returns {Promise} - Promise that resolves when flags are updated
   */
  updateFlags: () => {
    return flagsmith.identify(flagsmith.getState().identity?.id || 'anonymous');
  },
};

export default featureFlagService;
